import { TabContext, TabList, TabPanel } from '@material-ui/lab';
import { Box, Tab, } from '@mui/material'
import React, { useContext, } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from "swiper";
import TScard from '../SmallComponents/TScard';
import { ProductContext } from '../Context/ProductProvider';
import 'swiper/css'

const TopSellers = () => {
    const [value, setValue] = React.useState('1');

    const {state:{product}} = useContext(ProductContext)

    const handleChange = (event, newValue) => {
      setValue(newValue);
    };

    const watches = product.filter((e)=>{
      return e.category === 'watches'
    })
    const topPics = product.filter((e)=>{
      return e.highlight === 'top pics'
    })

    const stylePrimary = {
      color: 'red',
      fontWeight: 'bolder'
    }
    const styleSecondary = {
      color: 'gray',
      fontWeight: 'bold'
    }


  return (
    <Box bgcolor='black' pb={10} pt={5}>
    <Box style={{maxWidth: '75vw', margin:'auto', background: 'black', position: 'relative', left: '-1rem'}} >
        <h1 style={{color: 'white'}}>Top Sellers</h1>
        
        <Box sx={{ width: 'fit-content', typography: 'body1', position:'relative',   }}>
            <TabContext value={value}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider',width: 'fit-content',}}>
                <TabList onChange={handleChange} aria-label="lab API tabs example">
                  <Tab label="Smart Watches" value="1" style={value === '1'? stylePrimary: styleSecondary} />
                  <Tab label="Top Pics" value="2" style={value === '2'? stylePrimary: styleSecondary} />
                </TabList>
              </Box>

{/* ==============TAB 1================= */}

              <TabPanel value="1" >
                <Box style={{width: '75vw', display:'flex' }}>
                    <Swiper
                    slidesPerView={4}
                    spaceBetween={30}
                    slidesPerGroup={4}
                    loop={false}
                    loopFillGroupWithBlank={true}
                    pagination={{clickable: true}}
                    navigation={true}
                    modules={[Pagination]}
                    breakpoints={
                      {
                          320: {
                            slidesPerView: 1,
                            slidesPerGroup: 1,
                            spaceBetween: 100
                          },
                          500: {
                            slidesPerView: 2,
                            slidesPerGroup: 2,
                            spaceBetween: 20
                          },
                          900: {
                            slidesPerView: 3,
                            slidesPerGroup: 3,
                            spaceBetween: 20
                          },
                          1100:{
                            slidesPerView: 4,
                          slidesPerGroup: 4,
                          spaceBetween: 20
                        }
                      }
                    }
                    >{
                        watches.map((elm, i)=>{
                          return(
                            <SwiperSlide key={elm.id}>
                              <TScard name={elm.name} price={elm.price} image={elm.img}  id={elm} />
                            </SwiperSlide>
                          )
                        })
                      }
                    </Swiper>
                </Box>
              </TabPanel>




{/* ==============TAB 2================= */}
              <TabPanel value="2" >
                <Box style={{width: '75vw',}}>
                <Swiper
                    slidesPerView={4}
                    spaceBetween={30}
                    slidesPerGroup={1}
                    loop={false}
                    loopFillGroupWithBlank={true}
                    pagination={{
                      clickable: true,
                    }}
                    navigation={true}
                    modules={[Pagination, Navigation]}
                    breakpoints={
                      {
                          320: {
                            slidesPerView: 1,
                            slidesPerGroup: 1,
                            spaceBetween: 100
                          },
                          500: {
                            slidesPerView: 2,
                            slidesPerGroup: 2,
                            spaceBetween: 20
                          },
                          900: {
                            slidesPerView: 3,
                            slidesPerGroup: 3,
                            spaceBetween: 20
                          },
                          1100:{
                            slidesPerView: 4,
                          slidesPerGroup: 4,
                          spaceBetween: 20
                        }
                      }
                    }
                    >{
                      topPics.map((elm)=>{
                        return(
                          <SwiperSlide key={elm.id}>
                            <TScard name={elm.name} price={elm.price} image={elm.img}  id={elm}/>
                          </SwiperSlide>
                        )
                      })
                    }
                    </Swiper>
                </Box>
              </TabPanel>
            </TabContext>
        </Box>
    </Box>
    </Box>
  )
}

export default TopSellers


